(() => {
  const LOYALTY_CODE_PATTERN = /^SSLOYALTY-/i;

  function normalizeCode(code) {
    return String(code || "").trim().toLowerCase();
  }

  function isLoyaltyCode(code) {
    return LOYALTY_CODE_PATTERN.test(String(code || "").trim());
  }

  function conflictMessage(existingCodes, newCode, strings = window.cartStrings || {}) {
    const normalizedNewCode = normalizeCode(newCode);
    if (!normalizedNewCode) return null;

    const normalizedExistingCodes = Array.from(
      new Set(
        (Array.isArray(existingCodes) ? existingCodes : [])
          .map((code) => String(code || "").trim())
          .filter(Boolean)
      )
    );
    if (
      normalizedExistingCodes.some(
        (code) => normalizeCode(code) === normalizedNewCode
      )
    ) {
      return null;
    }

    const hasLoyaltyCode = normalizedExistingCodes.some(isLoyaltyCode);
    const hasPromotionCode = normalizedExistingCodes.some(
      (code) => !isLoyaltyCode(code)
    );

    if (isLoyaltyCode(newCode) && hasLoyaltyCode) {
      return strings.discount_loyalty_limit || strings.discount_error || null;
    }
    if (!isLoyaltyCode(newCode) && hasPromotionCode) {
      return (
        (hasLoyaltyCode
          ? strings.discount_promotion_limit_with_loyalty
          : strings.discount_promotion_limit) ||
        strings.discount_error ||
        null
      );
    }
    return null;
  }

  window.SilkSilkyDiscountCodePolicy = Object.freeze({
    conflictMessage,
    isLoyaltyCode,
  });
})();
